import { inject, Injectable } from '@angular/core';
import { ReplaySubject } from './util/rxjs';
import './util/rxjs';

import { HttpService } from './http.service';
import { ServerVersion } from './server-version.model';
import { LoginConfig } from './login-config.model';
import { map, tap } from "rxjs/operators";

@Injectable()
export class ConfigurationService {
  private versionStream = new ReplaySubject<ServerVersion>(1);
  private hasVersion = false;

  private loginStream = new ReplaySubject<LoginConfig>(1);
  private hasLoginConfig = false;
  private http = inject(HttpService);

  constructor() { }

  getVersion(force = false) {
    if (!this.hasVersion || force) {
      const options = { disableProgress: true };
      this.http.get<config.ServerVersion>('config/version', options)
        .map(version => new ServerVersion(version))
        .do(() => this.hasVersion = true)
        .subscribe(version => this.versionStream.next(version));
    }
    return this.versionStream.asObservable();
  }

  getLoginConfig(force: boolean = true) {
    if (!this.hasLoginConfig || force) {
      const options = { disableProgress: true };
      this.http.get<config.LoginConfig>('config/login', options).pipe(
        map(version => new LoginConfig(version)),
        tap(() => this.hasLoginConfig = true))
      .subscribe(loginInfo => this.loginStream.next(loginInfo));
    }
    return this.loginStream.asObservable();
  }
}

